import * as React from 'react';
import { observer } from 'mobx-react';
import MountNotifier from './MountNotifier';
import { NotificationsContext } from '../Notifications';
import { NotifiableStore } from '../ErrorActionableReaction';

interface Props {
  store: NotifiableStore;
}

const NotificationSource: React.FC<Props> = ({ store }) => {
  return (
    <NotificationsContext.Consumer>
      {(notificationsStore) => (
        <MountNotifier notifiableStore={store} notificationsStore={notificationsStore} />
      )}
    </NotificationsContext.Consumer>
  );
};

export default observer(NotificationSource);
